import { useQuery } from '@tanstack/react-query';
import { listConfigs, ListConfigsResponse } from '../services/configs-api';

/**
 * TanStack Query hook for listing configuration objects.
 * Refetches on window focus. Excludes pending deletions by default.
 */
export function useConfigs(includePendingDeletions = false) {
  return useQuery<ListConfigsResponse>({
    queryKey: ['configs', { includePendingDeletions }],
    queryFn: () => listConfigs(includePendingDeletions),
    refetchOnWindowFocus: true,
  });
}
